<div class="row page-header">
    <div class="col-12">
        <h1>Job Hazard Analysis <small>Jobsite safety inspection checklists</small></h1>
    </div>
</div>

<div [hidden]="isInitialLoading">
    <ul ngbNav [(activeId)]="activeTab" (activeIdChange)="tabChanged()" class="nav-tabs mb-3">
        @if (canViewDashboard) {
            <li [ngbNavItem]="0" [destroyOnHide]="false">
                <a ngbNavLink>Dashboard</a>
            </li>
        }
        <li [ngbNavItem]="1" [destroyOnHide]="false">
            <a ngbNavLink>Job Hazard Analyses</a>
        </li>
    </ul>

    @if (canViewDashboard) {
        <div [hidden]="!isDashboardTab">
            <app-job-hazard-analysis-dashboard (addForJob)="onAddForJob($event)"></app-job-hazard-analysis-dashboard>
        </div>
    }

    <div [hidden]="!isRecordsTab">
        <app-job-hazard-analysis-list></app-job-hazard-analysis-list>
    </div>
</div>
